import DOMPurify from 'dompurify';

function escapeHtmlPlain(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Matches server-side handling: plaintext → encoded with &lt;br/&gt;; HTML → DOMPurify */
export function blogRichTextPreviewHtml(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed.includes('<')) {
    const inner = trimmed
      .replace(/\r\n/g, '\n')
      .split('\n')
      .map(escapeHtmlPlain)
      .join('<br/>');
    return DOMPurify.sanitize(inner, { ALLOWED_TAGS: ['br'], ALLOWED_ATTR: [] });
  }

  return DOMPurify.sanitize(trimmed);
}
